import _ from 'lodash'

export default {
  migrate(expectedVersion, currentSaved) {
    let saved = _.cloneDeep(currentSaved)
    saved.dataVersion ||= 0

    console.log(`Migration: currentVersion = ${saved.dataVersion}`)
    console.log(`Migration: expectedVersion = ${expectedVersion}`)

    if (saved.dataVersion == 0) {
      console.log(`Migration: skipped`)
      saved.dataVersion = 0 < this.migrations.length
        ? this.migrations.slice(-1)[0].version
        : 1
      return saved
    }

    let migrations = this.migrations.filter(m => saved.dataVersion < m.version)
    if (migrations.length == 0) {
      console.log(`Migration: skipped`)
      return saved
    }

    migrations.forEach(m => {
      console.log(`Migration: v${saved.dataVersion} => v${m.version}: ${m.name}`)
      m.migrate(saved)
      saved.dataVersion = m.version
    })

    return saved
  },
  migrations: [
    {
      version: 4,
      name: 'rename name1 to name, name2 to memo',
      migrate: saved => {
        let migrateMember = m => {
          if (! m) return

          m.name = m.name1
          m.memo = m.name2
          delete m.name1
          delete m.name2
        }
        let migrateMembers = ms => ms.forEach(migrateMember)

        migrateMembers(saved.joined.members)
        migrateMember(saved.joined.lobbyHost)
        migrateMember(saved.joined.questHost)
        migrateMembers(saved.waiting.members)
        migrateMembers(saved.history.members)

        return saved
      },
    },
    {
      version: 5,
      name: 'remove unused fields',
      migrate: saved => {
        delete saved.others.captureAreaEnabled
        delete saved.others.listHideWhenInQuest
        delete saved.others.listHideWhenInfoDisplayOnRightSide
        delete saved.others.captureAreaMoveInQuest
        delete saved.others.questHostCountDisplay
        delete saved.others.sortieCountDisplay
      }
    },
    {
      version: 6,
      name: 'remove unused field: commandToEntryHunterName',
      migrate: saved => {
        delete saved.settingsForYouTube.commandToEntryHunterName
      }
    },
    {
      version: 7,
      name: 'add field: totalSortieCount',
      migrate: saved => {
        saved.joined.members.forEach(m => m.totalSortieCount = 0)
        saved.waiting.members.forEach(m => m.totalSortieCount = 0)
        saved.history.members.forEach(m => m.totalSortieCount = 0)
      }
    },
    {
      version: 8,
      name: 'add field: globalTotalSortieCount',
      migrate: saved => {
        saved.joined.members.forEach(m => m.grandTotalSortieCount = 0)
        saved.waiting.members.forEach(m => m.grandTotalSortieCount = 0)
        saved.history.members.forEach(m => m.grandTotalSortieCount = 0)
      }
    },
  ],
}
